export default __webpack_public_path__ + "static/media/trackometer.7f7e6e63.png";